import {
    IconLogoFooterText,
    IconLogoSmall,
    IconLogoText,
    Link,
    VisuallyHidden,
} from '@ds/components'

import styles from './Logo.module.css'

type TLogoProps = {
    href: string
    label: string
}

export const Logo = ({ href, label }: TLogoProps) => (
    <Link variant="primary" href={href} className={styles.logo}>
        <IconLogoSmall className={styles.mark} />
        <span className={styles.words} data-logo-words>
            <IconLogoText className={styles.text} />
            <IconLogoFooterText className={styles.footerText} />
        </span>
        <VisuallyHidden>{label}</VisuallyHidden>
    </Link>
)
